import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { URL, colors } from "../utils/constant";
import Typography from "@mui/material/Typography";
// import { Language } from "../Languages/Language";

// import DropDown from "../component/shared/DropDown";
import { useForm } from "react-hook-form";
import { useCallback } from "react";
import { useAuth } from "../data/talons/auth/useAuth";
// import { useSelector } from "react-redux";
// import { getApiData } from "../data/selector/auth.selector";
// import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DropDown2 from "../component/shared/DropDown2";
import { useDispatch, useSelector } from "react-redux";
import { setMobileNo } from "../data/reducer/auth.reducer";
import GlobalPageLoader from "../data/talons/loader/useFullPageLoader";
import {
  hidePageLoader,
  showPageLoader,
} from "../data/reducer/pageLoader.reducer";
import {
  getLanguage,
  getLanguageNumber,
} from "../data/selector/language.selector";
import {
  setLanguageNumber,
  setSelectedLanguage,
} from "../data/reducer/language.reducer";
import { LanguageChange } from "../Languages/Language";
import { useEffect } from "react";
import { setToken } from "../data/reducer/appState.reducer";
import { useState } from "react";
import { English } from "../Languages/en";
import { Spanish } from "../Languages/sp";
import { get, size } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { getUserToken } from "../data/selector/appState.selector";

export default function Login() {
  const { login, verifyOTPApi, eproCodeLogin } = useAuth();
  const [NumberComponent, setNumberComponent] = React.useState(false);
  const [OtpComponent, setOtpComponent] = React.useState(false);
  const [LanguageComponrnt, setLanguageComponrnt] = React.useState(false);
  const Language = useSelector(getLanguage);
  const number = useSelector(getLanguageNumber);
  // console.log(Language, "ccccccc");
  const [Number, setNumber] = React.useState("");
  const [language, setLanguage] = React.useState("");

  const dispatch = useDispatch();
  // console.log(language, "hhhhhhhh");
  const [timer, setTimer] = useState(30);
  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );
  useEffect(() => {
    // console.log(dropdownValue, "vkvkvkv");
    if (!number) {
      // console.log("noneWnglish");
      dispatch(setSelectedLanguage(English));
    } else if (number == 1) {
      // console.log("english");
      dispatch(setSelectedLanguage(English));
    } else if (number == 2) {
      // console.log("spanish");
      dispatch(setSelectedLanguage(Spanish));
    }
    // dispatch(setSelectedLanguage(Spanish));
    // console.log("nnnn");
  }, [number]);

  const handleNumberComponent = () => {
    if (language === "") {
      // console.log("Please select language");
      toast.error("Please select language", {
        position: "bottom-right",
      });
    } else {
      // dispatch(setLanguageNumber(language));
      setNumberComponent(false);
      setOtpComponent(true);
      setLanguageComponrnt(true);
    }
  };
  const setLoginToken = () => {
    const uuid = uuidv4();

    dispatch(setToken(uuid));
    window.location.href = URL.patientDetails;
  };
  const handleOtpComponent = () => {
    setNumberComponent(false);
    setOtpComponent(true);
    setLanguageComponrnt(true);
    setNumber(getValues("MobileNo"));
  };
  const onlyNumbers = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");
    if (e.target.value.toString().length === 0) return;
    return (e.target.value = Math.max(0, parseInt(e.target.value))
      .toString()
      .slice(0, 10));
  };
  const { register, handleSubmit, getValues } = useForm({
    defaultValues: {
      MobileNo: "",
      verifyOtp: "",
    },
  });
  // let resendOtp;
  const Languages = Language.Language_Menu;
  const onSubmit = useCallback(
    async (data, e) => {
      e.preventDefault();
      if (!data?.verifyOtp) {
        toast.error("Invalid verification Code", {
          position: "bottom-right",
        });
        return;
      }
      if (data?.verifyOtp) {
        const response = await eproCodeLogin(data?.verifyOtp);
        console.log(response, "response");
        if (response[0]?.Message === null) {
          toast.success("E-Pro Code Verified", {
            position: "bottom-right",
          });
          setLoginToken();
        } else {
          toast.error(
            response?.Message ? response?.Message : response[0]?.Message,
            {
              position: "bottom-right",
            }
          );
        }
      }
    },
    // eslint-disable-next-line
    [login, verifyOTPApi, language]
  );
  useEffect(() => {
    dispatch(setToken(""));
  }, []);
  useEffect(() => {
    OtpComponent && timer > 0 && setTimeout(timeOutCallback, 1000);
  }, [timer, OtpComponent]);
  return (
    <>
      {GlobalPageLoader()}

      <ToastContainer />
      <Grid
        container
        component="main"
        className="d-flex justify-content-center mx-auto my-5 p-0"
        sx={{ height: "80vh", width: "80vw" }}
      >
        <CssBaseline />
        <Grid item xs={12} sm={8} md={5} lg={4} elevation={6}>
          <Box
            className="m-4"
            sx={{
              //   my: 8,
              mx: 8,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box className="mb-3">
              <img alt="logo" src="./Images/epro.svg" />
            </Box>

            <Box
              component="form"
              noValidate
              sx={{ mt: 1 }}
              onSubmit={handleSubmit(onSubmit)}
            >
              {LanguageComponrnt === false ? (
                <>
                  <Typography component="h5" variant="h3" className="mb-4 mt-5">
                    {Language.LoginTitle?.language_title}
                  </Typography>
                  <DropDown2
                    values={Languages}
                    selected={Language.LoginTitle?.selectLang_label}
                    setLanguage={setLanguage}
                    language={language}
                  />

                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 1,
                      mb: 2,
                      backgroundColor: colors.blue,
                      "&:hover": {
                        backgroundColor: colors.blue,
                      },
                    }}
                    onClick={handleNumberComponent}
                  >
                    {Language.LoginTitle?.proceed_btnText}
                  </Button>
                </>
              ) : (
                ""
              )}

              {OtpComponent ? (
                <>
                  <Typography component="h5" variant="h3" className="mb-4 mt-5">
                    {Language.LoginTitle.varifyNum_title}
                  </Typography>

                  <TextField
                    // className="mt-2"
                    margin="normal"
                    name="verifyOtp"
                    required
                    fullWidth
                    id="number"
                    label={Language.LoginTitle?.enterOTP_label}
                    autoComplete="number"
                    autoFocus
                    // onInput={(e) => onlyNumbers(e)}
                    {...register("verifyOtp")}
                  />

                  <Button
                    onClick={handleSubmit(onSubmit)}
                    type="button"
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 1,
                      mb: 2,
                      backgroundColor: colors.blue,
                      "&:hover": {
                        backgroundColor: colors.blue,
                      },
                    }}
                  >
                    {Language.LoginTitle?.verifyOTP_btnText}
                  </Button>
                </>
              ) : (
                ""
              )}
            </Box>
          </Box>
        </Grid>

        <Grid
          className="custom-grid"
          item
          xs={false}
          sm={false}
          md={7}
          sx={{
            backgroundColor: colors.imgBackground,
            backgroundImage: "url(./Images/isolation_mode.svg)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center bottom",
            backgroundSize: "contain",
          }}
        >
          <Typography className="fw-bold p-5" component="h5" variant="h5">
            {Language.LoginTitle?.backImage_title}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
